import { toLower, size, chain } from "lodash"
import { getPortfolioMenuItems } from "modules/portfolio-root/selectors/menu"
import { getWatchlistMenuItems } from "modules/watchlist-root/selectors/menu"
import { getTopicMenuItems } from "modules/research-topic-root/selectors/menu"
import { getSwapMenuItems } from "./selectors/swaps"

export function getFullResourceType(shortType) {
  switch (shortType) {
    case "t":
      return "RESEARCH_TOPIC"
    case "watchlist":
      return "WATCHLIST"
    case "f":
      return "FORECAST"
    case "b":
      return "SWAP"
    case "template":
      return "TEMPLATE"
    case "solution":
      return "SOLUTION"
    case "p":
    default:
      return "PORTFOLIO"
  }
}

export function getShortResourceType(fullType) {
  switch (toLower(fullType)) {
    case "topic":
    case "research_topic":
      return "t"
    case "watchlist":
      return "watchlist"
    case "forecast":
      return "f"
    case "template":
      return "template"
    case "solution":
      return "solution"
    case "basket":
    case "swap":
      return "b"
    case "portfolio":
    default:
      return "p"
  }
}

export function getApiErrorMessage(apiMessages, resourceType) {
  if (size(apiMessages.errors) > 0) {
    return chain(apiMessages.errors)
      .map(({ message }) => message)
      .join("\n")
      .value()
  }
  return `An error occurred while creating the ${resourceType}.`
}

export const renderAction = (buttons) => {
  return chain(buttons)
    .find(({ condition }) => condition)
    .get("render")
    .value()
}

export const getResourceTypeLabel = (resourceType) => {
  if (resourceType === "topic") {
    return "research topic"
  }
  return resourceType
}

export const makeMenuItems = (account, resource, isOpPro, { models, intradayAccountEnabled }) => {
  if (!resource) { return null }
  switch (resource.resourceType) {
    case "portfolio":
      return getPortfolioMenuItems(account, resource, models, intradayAccountEnabled, isOpPro)
    case "watchlist":
      return getWatchlistMenuItems(account, resource, isOpPro)
    case "swap":
      return getSwapMenuItems(account, resource, isOpPro)
    case "topic":
      // Not passing isOpPro to research topic items becase RTs are not available to OpPro
      return getTopicMenuItems(account, resource)
  }
}
